import { UI, HStack, VStack, StackTypes } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

type Info = {
  label: string;
  value: string;
};

export interface SubscriptionItemDetailsInfosProps {
  infos: [Info, Info, Info, Info, Info];
}

const InfoItem: React.FC<Info & { w: StackTypes.Props['w'] }> = ({ label, value, w }) => (
  <VStack w={w}>
    <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
      {label}
    </UI.Text>
    <UI.Text>{value}</UI.Text>
  </VStack>
);

export const SubscriptionItemDetailsInfos: React.FC<SubscriptionItemDetailsInfosProps> = ({
  infos,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return (
      <VStack space="stack.xxxs">
        <HStack alignItems="center">
          <InfoItem w="1/2" {...infos[0]} />
          <InfoItem w="1/2" {...infos[1]} />
        </HStack>
        <HStack alignItems="center">
          <InfoItem w="1/2" {...infos[2]} />
          <InfoItem w="1/2" {...infos[3]} />
        </HStack>
        <HStack alignItems="center">
          <InfoItem w="1/2" {...infos[4]} />
        </HStack>
      </VStack>
    );
  }

  return (
    <VStack space="stack.xxxs">
      <HStack alignItems="center">
        <InfoItem w="1/3" {...infos[0]} />
        <InfoItem w="1/3" {...infos[1]} />
        <InfoItem w="1/3" {...infos[2]} />
      </HStack>
      <HStack alignItems="center">
        <InfoItem w="1/3" {...infos[3]} />
        <InfoItem w="1/3" {...infos[4]} />
      </HStack>
    </VStack>
  );
};
